import type { CustomerPreferences } from "../data/customerData";
import type { MenuDish } from "../types/menu";

function normalizeToken(value: string) {
  return value.trim().toLowerCase();
}

function isShawarmaDish(dish: MenuDish) {
  const haystack = [dish.category, dish.id, dish.name].map(normalizeToken).join(" ");
  return haystack.includes("shawarma") || haystack.includes("shaurma") || haystack.includes("шаур");
}

function resolveOnionOptionId(dish: MenuDish) {
  const onionOption = dish.customization?.removableIngredients?.find((item) => {
    const id = normalizeToken(item.id);
    const label = normalizeToken(item.label);

    return id === "onion" || label.includes("лук");
  });

  return onionOption?.id ?? null;
}

export function getDefaultRemovedIngredientIds(
  dish: MenuDish,
  preferences: CustomerPreferences | null | undefined
) {
  if (!preferences?.removeOnionByDefault || !isShawarmaDish(dish)) {
    return [];
  }

  const onionOptionId = resolveOnionOptionId(dish);
  return onionOptionId ? [onionOptionId] : [];
}
